import { cva as r } from "../../modules/index.es4.js";
const a = r(
  "block relative overflow-clip rounded-2xl border border-gray-200 bg-background text-foreground relative dark:border-gray-200/20",
  {
    variants: {}
  }
);
export {
  a as cardVariants
};
//# sourceMappingURL=Card.styles.es.js.map
